import { Http } from './http';
import { CirculoProfile } from '@types';

class CirculoHttp extends Http {

  prefix = 'circulo';

  async getProfileByUserId(userId: number): Promise<CirculoProfile> {
    const res = await this.get<CirculoProfile>(`/get-profile/${userId}`);

    return res.data;
  }

  async check(userId: number): Promise<CirculoProfile> {
    const res = await this.get<CirculoProfile>(`/check/${userId}`);

    return res.data;
  }
}

export const circuloHttp = new CirculoHttp();
